<template>
  <div class="source-echart">
    <div :id="'source'+timeId" class="source-pie"></div>
  </div>
</template>

<script>
import 'echarts/lib/component/legendScroll';

export default {
  props: {
    isMountedRender: {
      // 防止数据未获取就直接宣染dom
      type: Boolean,
      default: false,
    },
    pieDataArray: {
      // 饼图数据
      type: Array,
      default: () => [{ name: '暂无数据', value: 0 }],
    },
  },
  data() {
    return {
      timeId: new Date() * 1 + Math.random(),
    };
  },
  watch: {
    pieDataArray: {
      handler() {
        this.myEchartData();
      },
      deep: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    // console.log('dddd', this.xDataArray, this.yDataArray);
    // console.log('ssiii', `source${this.timeId}`);
    this.myEchart = this.$echarts.init(
      // eslint-disable-next-line comma-dangle
      document.getElementById(`source${this.timeId}`)
    );
    this.myEchartData();

    // 当窗口发生变化时
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    myEchartData() {
      const option = {
        // title: {
        //   text: 'source分布',
        //   //   subtext: 'Fake Data',// 副标题
        //   left: 'center',
        // },
        tooltip: {
          trigger: 'item', // 数据项图形触发提示
        },
        legend: {
          orient: 'vertical', // 图标是纵 vertical，横 horizontal
          left: 'right', // 图标自适应的位置
          // bottom: isMoreDate ? 40 : 0,
          type: 'scroll',
          height: 130,
          itemWidth: 10,
          itemHeight: 10,
          // formatter: (name) => (name.length > 10
          //   ? name.replace(new RegExp(`^(.{${name.length / 2}})`, 'g'), '$1\n') : name),
          // name.split('').map((item, index) =>
          // (!((index + 1) % 10) ? `${item}\n` : item)).join(''),
        },
        // color: ['#fc8251', '#5470c6', '#91cd77', '#ef6567', '#f9c956', '#75bedc'],
        series: [
          {
            name: 'source分布',
            type: 'pie',
            radius: '50%', // 整个圆的大小对于容器百分比
            colorBy: 'data', // 每个数据项都使用不同的颜色
            data: this.pieDataArray,
            emphasis: {
              // 点击高亮设置
              itemStyle: {
                shadowBlur: 10, // 高亮阴影面积
                shadowOffsetX: 0, // 高亮阴影偏移
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            selectedMode: 'single', // 是否支持点击多选
          },
        ],
      };
      //  判断是否有数据在渲染饼图
      this.myEchart.clear();
      this.myEchart.setOption(option);
    },
    handleResize() {
      this.myEchart.resize();
    },
  },
};
</script>

<style lang="scss">
// .source-echart {
//   height: 300px;
//   // width: 500px;
//   border: 1px solid #c0c4cc;
//   border-radius: 2%;
// }
.source-pie {
  height: 300px;
}
</style>
